import { render, staticRenderFns } from "./ServiceTypeInfo.vue?vue&type=template&id=2cfd5cbf&"
import script from "./ServiceTypeInfo.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports